<script setup lang="ts">
import { useDeviceState } from "@/stores/DeviceState";
import DRDropdownItem from "@/components/UI/DRDropdownItem.vue";
import { useDownloadDwg } from "./downloadFile";

const props = defineProps<{
  drawingId?: number;
  revisionId?: number;
  fileName?: string;
}>();

const deviceState = useDeviceState();
const { mutateAsync, isLoading: showDownloadSpinner } = useDownloadDwg();

async function downloadFile() {
  if (!props.drawingId || !props.fileName || !props.revisionId) {
    return;
  }
  await mutateAsync(props.fileName, props.drawingId, props.revisionId);
}
</script>
<template>
  <DRDropdownItem
    :disabled="!drawingId || !fileName || !revisionId || !deviceState.isOnline"
    :loading="showDownloadSpinner"
    @select="downloadFile()"
    icon="bi-file-earmark-arrow-down"
    :label="$t('drawings.download.dwg')"
  />
</template>
